module.exports = __webpack_public_path__ + "static/media/LogicWedge2_4_drag_4.7b314ea1.png";